import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { reduxForm, reset, Field } from "redux-form";
import { Link } from "react-router-dom";
import Button from "react-md/lib/Buttons/Button";
import logo from "static/images/logo.png";
import { MSpinner } from "components/Shared";
import { FocusedInputField } from "components/FormElements";
import { userLogin, persistLogin } from "actions/user";
import { validateUserLogin as validate } from "validations";

let triedToken = false;
const Login = ({
  userLogin,
  persistLogin,
  handleSubmit,
  invalid,
  pristine,
  submitting,
  isFetching,
  triedLogin,
}) => {
  if (!triedToken && !triedLogin) {
    triedToken = true;
    persistLogin();
  } else if (isFetching) {
    return (
      <div className="md-grid md-cell login-wrapper">
        <div className="login-form">
          <img src={logo} alt="logo.png" className="mueller-logo" />
          <MSpinner />
        </div>
      </div>
    );
  }
  return (
    <div className="md-grid md-cell login-wrapper">
      <div className="login-form">
        <img src={logo} alt="logo.png" className="mueller-logo" />
        <h3 className="mueller-title" data-test="title">Access Mueller Reports</h3>
        <form onSubmit={handleSubmit(userLogin)}>
          <Field
            id="username"
            name="username"
            component={FocusedInputField}
            type="text"
            hintText="Username"
            dataTest="username"
          />
          <Field
            id="password"
            name="password"
            component={FocusedInputField}
            type="password"
            hintText="Password"
            dataTest="password"
          />
          <Button
            primary
            raised
            type="submit"
            children="Login"
            className="full-width m-t-10 login-button"
            disabled={invalid || pristine || submitting}
            data-test="login-button"
          />
          <Link to="/forgot-password" className="link" data-test="forgot-password">
            Forgot Password?
          </Link>
        </form>
      </div>
    </div>
  );
};

Login.propTypes = {
  userLogin: PropTypes.func.isRequired,
  persistLogin: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool,
  triedLogin: PropTypes.bool,
};

export default connect(
  state => ({
    isFetching: state.user.isFetching,
    triedLogin: state.user.triedLogin
  }),
  dispatch => ({
    userLogin: user => dispatch(userLogin(user)).then(() => reset("Login")),
    persistLogin: () => dispatch(persistLogin()).then(() => reset("Login")),
  })
)(reduxForm({
  form: "Login",
  validate,
})(Login));
